






















































































import Vue from 'vue'

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    months(): number {
      return this.$store.getters['valuationEdit/monthsPeriod']
    },
    buildingType(): string {
      return this.$store.getters['valuationEdit/buildingType']
    },
    layout(): number {
      return this.$store.getters['valuationEdit/layout']
    },
    garagePrice(): any {
      return this.$store.getters['valuationEdit/garagePrice']
    },
  },
})
